import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject     } from 'rxjs';
import { map, repeat, switchMap, tap } from 'rxjs/operators';

import { CountersService, QueryCollectorService, SidebarStorageService } from '@shared/services';
import { ReferralsCountersModel } from '@shared/models';

@Injectable()
export class ReferralsCountersService {
  static COUNTERS_API: string = `api/portal/v3/referral_program_referees_counters`;

  private reloadCounter$ = new Subject<void>();
  private skipUpdate: boolean;

  constructor(
    private http:                  HttpClient,
    private sidebarStorageService: SidebarStorageService,
    private countersService:       CountersService,
    private queryCollectorService: QueryCollectorService,
  ) { }

  get Counters(): Observable<ReferralsCountersModel> {
    return this.requestCounters().pipe(
      repeat({delay: () => this.reloadCounter$})
    );
  }

  reloadCounters(skipUpdate: boolean = null): void {
    this.skipUpdate = skipUpdate;
    this.reloadCounter$.next();
  }

  private requestCounters(): Observable<ReferralsCountersModel> {
    return of(ReferralsCountersService.COUNTERS_API).pipe(
      map(url => url + this.queryCollectorService.getCountersQuery()),
      switchMap(url => this.http.get<ReferralsCountersModel>(url)),
      tap(({active}) => {
        this.sidebarStorageService.changeActiveReferralsCount(active.length);
        this.countersService.checkForUpdates({active}, 'referrals', this.skipUpdate);
        this.skipUpdate = null;
      })
    );
  }

}
